<template>
  <div class="home-container" :class="isHome ? 'is-home' : 'is-category'">
    <MainMenu />
    <div>
      <div class="search-box" v-if="isHome || isSearch">
        <v-text-field
          hide-details
          prepend-icon="mdi-magnify"
          single-line
          v-model="searchText"
          @keydown.enter="onSearch"
          class="search-input"
          :placeholder="$t('search.placeholder')"
        ></v-text-field>
      </div>
      <h1 class="home-title" v-if="isHome">
        {{ $t('common.news') }}
      </h1>
      <div class="search-title" v-else-if="isSearch">
        <p v-if="articles.length">
          {{ $t('search.foundResults') }} {{ articles.length }}
        </p>
      </div>
      <div class="category-title-container" v-else-if="validQuery">
        <div class="category-title">
          <h1 class="category-name">
            {{ $t('menu.' + selectedCategory) }}
            <span v-if="selectedLanguage">
              ({{ $t('common.' + selectedLanguage) }})
            </span>
          </h1>
          <p>
            <span
              :class="{
                'subcategory-id': true,
                capitalized: validSubcategories[selectedSubcategory].hideId
              }"
              >{{
                validSubcategories[selectedSubcategory].hideId
                  ? validSubcategories[selectedSubcategory].name
                  : validSubcategories[selectedSubcategory].id + ' '
              }}</span
            >
            <span v-if="!validSubcategories[selectedSubcategory].hideId">{{
              validSubcategories[selectedSubcategory].name
            }}</span>
          </p>
        </div>
        <div class="category-subtitle">
          <p>
            {{ validSubcategories[selectedSubcategory].title }}
            {{ validSubcategories[selectedSubcategory].subtitle }}
          </p>
        </div>
      </div>
      <div class="home-loading" v-if="!loaded">
        <v-progress-circular
          indeterminate
          size="64"
          color="secondary"
        ></v-progress-circular>
      </div>
      <!-- Showing slider only on SM and UP devices -->
      <PdfSlider
        v-else-if="$vuetify.breakpoint.smAndUp"
        :articles="articles"
        :searchTexts="searchTexts"
      />
      <!-- Showing list only on XS devices -->
      <PdfList v-else :articles="articles" :searchTexts="searchTexts" />
    </div>
  </div>
</template>

<script>
import MainMenu from '@/components/MainMenu'
import PdfSlider from '@/components/PdfSlider'
import PdfList from '@/components/PdfList'
import {
  CATEGORIES_OBJ,
  SUBCATEGORIES_MAP,
  LANGUAGES_MAP
} from '@/consts/categories'
import { getArticlesByCat, getArticlesBySearch } from '@/consts/articles'

export default {
  components: {
    MainMenu,
    PdfSlider,
    PdfList
  },
  props: ['category', 'subcategory', 'language'],
  data: () => ({
    articles: [],
    loaded: false,
    isHome: false,
    selectedCategory: null,
    selectedSubcategory: null,
    selectedLanguage: null,
    validQuery: true,
    validCategories: CATEGORIES_OBJ,
    validSubcategories: SUBCATEGORIES_MAP,
    validLanguages: LANGUAGES_MAP,
    isSearch: false,
    searchText: '',
    searchTexts: []
  }),
  created() {
    if (this.$route.meta.isHome) {
      this.isHome = true
    }
    if (this.$route.query.s) {
      this.searchText = this.$route.query.s
    }
    if (this.$route.meta.isSearch) {
      this.isSearch = true
      this.searchArticles(this.$route.query.s)
      this.searchTexts = this.$route.query.s.split(' ')
    } else {
      this.getArticles()
    }
  },
  methods: {
    searchArticles(search) {
      this.articles = getArticlesBySearch(search)
      setTimeout(() => {
        this.loaded = true
      }, 500)
    },
    onSearch() {
      if (this.searchText) {
        if (this.searchText !== this.$route.query.s) {
          this.$router.push({
            name: 'search',
            query: { ...this.$route.query, s: this.searchText }
          })
          if (this.isSearch) {
            this.loaded = false
            this.searchTexts = this.searchText.split(' ')
            this.searchArticles(this.searchText)
          }
        }
      } else {
        this.$router.push({
          name: 'home'
        })
      }
    },
    getArticles() {
      var category = 'new'
      if (!this.isHome && !this.isSearch && this.category) {
        //Validating Category
        if (this.validCategories[this.category]) {
          category = this.validCategories[this.category]
          this.selectedCategory = category

          //Validating Subcategory
          if (this.subcategory && this.validSubcategories[this.subcategory]) {
            category += '_' + this.subcategory
            this.selectedSubcategory = this.subcategory

            //Validating Language
            if (this.language) {
              if (this.validLanguages[this.language]) {
                category += '_' + this.language
                this.selectedLanguage = this.language
              } else {
                this.validQuery = false
              }
            }
          } else {
            this.validQuery = false
          }
        } else {
          this.validQuery = false
        }
      }
      if (this.validQuery) {
        this.articles = getArticlesByCat(category)
        setTimeout(() => {
          this.loaded = true
        }, 500)
      } else {
        this.loaded = true
      }
    }
  }
}
</script>
<style lang="scss">
.home-container {
  .search-box {
    display: flex;
    justify-content: center;
    padding: 10px;
    .search-input {
      max-width: 320px;
    }
  }
  .home-loading {
    display: flex;
    justify-content: center;
    margin-top: 100px;
  }

  &.is-home {
    .home-title {
      text-align: center;
      color: #024690;
      padding: 10px 0;
    }
  }
  &.is-category {
    .category-title {
      background: #024690;
      color: white;
      text-align: center;
      margin-bottom: 15px;

      .category-name {
        @media only screen and (max-width: 599px) {
          font-size: 22px;
          padding-top: 8px;
        }
      }
      .subcategory-id {
        font-weight: bold;
        text-transform: uppercase;
      }
    }
    .category-subtitle {
      font-size: 1.5em;
      text-align: center;
      color: #044690;
      font-weight: bold;
    }
    .search-title {
      text-align: center;
      color: #024690;
    }
  }
}
</style>
